import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type IAlertProps } from 'shared/ui/Alert/types'
import { allowedRcsExtensionsFiltered } from 'entities/Rcs/types/RcsValidFilesTypes'

type IRcsNotSupportedFilesAlertProps = {
  alertProps?: Partial<IAlertProps>
  onClose?: () => void
}

export const RcsNotSupportedFilesAlert = observer(
  ({ alertProps, onClose }: IRcsNotSupportedFilesAlertProps) => {
    const description =
      'Unsupported file type. RCS supports: ' + allowedRcsExtensionsFiltered.join(', ')

    return (
      <Alert
        {...alertProps}
        item={{
          type: 'error',
          desc: description,
        }}
        onClose={onClose}
      />
    )
  }
)
